export enum PermissionsPref {
	ENABLED = 'permission.v2Enabled',
}

export enum PermissionName {
	// "app" only - available in the user object's `permissions` array
	APPROVE_DOWNLOADS = 'APPROVE_DOWNLOADS',
	CREATE_API_TOKENS = 'CREATE_API_TOKENS',
	MANAGE_PORTALS = 'MANAGE_PORTALS',
	MANAGE_VOCABULARIES = 'MANAGE_VOCABULARIES',
	SHARE_WITH_TEAM = 'SHARE_WITH_TEAM',
	UPLOAD_ATTRIBUTE_DATA = 'UPLOAD_ATTRIBUTE_DATA',
	VIEW_STATISTICS = 'VIEW_STATISTICS',
	// "magic" permissions- available in the user object's `permissions` array
	IS_ADMIN = 'IS_ADMIN',

	// "asset" permissions
	MANAGE_VERSIONS = 'MANAGE_VERSIONS',
	MANAGE_VIEWS = 'MANAGE_VIEWS',
	MANAGE_RELATIONSHIPS = 'MANAGE_RELATIONSHIPS',
	MANAGE_TRANSCRIPTIONS = 'MANAGE_TRANSCRIPTIONS',
	MANAGE_VIDEO_CLIPS = 'MANAGE_VIDEO_CLIPS',
	REIMPORT = 'REIMPORT',
	SET_CUSTOM_THUMBNAIL = 'SET_CUSTOM_THUMBNAIL',
	VIEW_EMBEDDED_DATA = 'VIEW_EMBEDDED_DATA',
	VIEW_USAGE_DATA = 'VIEW_USAGE_DATA',

	// "category" permissions
	ADD_FOLDERS = 'ADD_FOLDERS',
	EDIT_FOLDERS = 'EDIT_FOLDERS',
	REORDER_FOLDERS = 'REORDER_FOLDERS',
	DELETE_FOLDERS = 'DELETE_FOLDERS',

	// "hybrid" permissions - available in the user object's `permissions` array
	ARCHIVE = 'ARCHIVE',
	CREATE_REVIEWS = 'CREATE_REVIEWS',
	CREATE_SHARE_LINKS = 'CREATE_SHARE_LINKS',
	CREATE_UPLOAD_REQUESTS = 'CREATE_UPLOAD_REQUESTS',
	DELETE = 'DELETE',
	DOWNLOAD = 'DOWNLOAD',
	EDIT_ATTRIBUTE_VALUES = 'EDIT_ATTRIBUTE_VALUES',
	EXPIRE = 'EXPIRE',
	ORGANIZE = 'ORGANIZE',
	RESYNC = 'RESYNC',
	UPLOAD = 'UPLOAD',
	VIEW_ATTRIBUTE_HISTORY = 'VIEW_ATTRIBUTE_HISTORY',

	// psuedo
	VIEW = 'VIEW',
}

export const CATEGORY_PERMISSION_NAMES = [
	PermissionName.ADD_FOLDERS,
	PermissionName.EDIT_FOLDERS,
	PermissionName.REORDER_FOLDERS,
	PermissionName.DELETE_FOLDERS,
] as const;

export const SHARING_AND_COLLABORATION_PERMISSIONS = [
	PermissionName.SHARE_WITH_TEAM,
	PermissionName.CREATE_SHARE_LINKS,
	PermissionName.CREATE_UPLOAD_REQUESTS,
	PermissionName.CREATE_REVIEWS,
] as const;

export const ADMINISTRATION_PERMISSION_NAMES = [
	PermissionName.MANAGE_VOCABULARIES,
	PermissionName.MANAGE_PORTALS,
	PermissionName.VIEW_STATISTICS,
	PermissionName.CREATE_API_TOKENS,
	PermissionName.APPROVE_DOWNLOADS,
] as const;

export const ASSET_PERMISSION_NAMES = [
	PermissionName.VIEW,
	PermissionName.DOWNLOAD,
	PermissionName.EDIT_ATTRIBUTE_VALUES,
	PermissionName.UPLOAD,
	PermissionName.MANAGE_VIEWS,
	PermissionName.MANAGE_VERSIONS,
	PermissionName.MANAGE_TRANSCRIPTIONS,
	PermissionName.MANAGE_VIDEO_CLIPS,
	PermissionName.SET_CUSTOM_THUMBNAIL,
	PermissionName.VIEW_EMBEDDED_DATA,
	PermissionName.MANAGE_RELATIONSHIPS,
	PermissionName.UPLOAD_ATTRIBUTE_DATA,
	PermissionName.VIEW_USAGE_DATA,
	PermissionName.VIEW_ATTRIBUTE_HISTORY,
	PermissionName.ORGANIZE,
	PermissionName.REIMPORT,
	PermissionName.EXPIRE,
	PermissionName.RESYNC,
	PermissionName.DELETE,
	// PermissionName.ARCHIVE,
] as const;
